// extracted by mini-css-extract-plugin
export default {"modal":"LimitModal_modal__jT1m-","frame":"LimitModal_frame__XmqFT"};